import Request from './request';
import store from '@/store.js';

async function fetch(data) {
    return Request('get', "api/settings", data);
}

async function bussinessSetting(data) {
    return Request('get', "api/settings/businessSetting", data);
}

async function batchSave(data) {
    return Request('post', "api/settings/batchSave", data);
}

async function kdnSave(data) {
    return Request('post', "api/settings/logistics-api-setting", data);
}

async function settings(data){
    return Request("get","api/settings?" + data)
}

async function getSettings(data){
    return Request("get","api/settings", data)
}

async function getThirdApiAccessToken() {
    return Request('get', "api/settings/getThirdApiToken");
}

async function getWechatTemplateThreeSettings(){
    return Request("get","api/settings/wechat-template-three")
}

async function getThirdApiSelect(){
    return Request("get","api/settings/thirdApiSelect")
}

async function getThirdApiSetting(){
    return Request("get","api/settings/getThirdApiSetting")
}

async function saveThirdApiSetting(data){
    return Request("post","api/settings/saveThirdApiSetting",data)
}

async function getSubAccountEditStatus(data) {
    const response = await Request('get', "api/settings/getSubAccountEditStatus", data);
    if (response.data && response.data.status.isOK()) {
        store.commit("subAccountEditStatus", response.data);
    }
    return response;
}

export default {
    fetch,
    bussinessSetting,
    batchSave,
    settings,
    getSettings,
    getThirdApiAccessToken,
    kdnSave,
    getWechatTemplateThreeSettings,
    getThirdApiSelect,
    getThirdApiSetting,
    saveThirdApiSetting,
    getSubAccountEditStatus,
}
